import { isAxiosError } from 'axios';

interface ValidationError {
  message: string;
  path: string;
}

interface APIErrorResponse {
  message: string;
  errors?: ValidationError[];
}

export function getErrorMessage(err: Error) {
  let message = 'An unknown error occurred. Please try again.';

  if (isAxiosError<APIErrorResponse>(err) && err.response?.data?.message) {
    message = err.response?.data?.message;
  } else if (err.message) {
    message = err.message;
  }

  return message;
}

export function getValidationErrors(err: Error): ValidationError[] {
  if (isAxiosError<APIErrorResponse>(err) && err.response?.data?.errors) {
    return err.response.data.errors;
  }
  return [];
}

export function isValidationError(err: Error): boolean {
  return getValidationErrors(err).length > 0;
}
